import React, { useState, useEffect, useCallback } from 'react';
import IdleScreen from './components/IdleScreen';
import CheckInFlow from './components/CheckInFlow';
import CheckOutFlow from './components/CheckOutFlow';
import StaffAttendanceFlow from './components/StaffAttendanceFlow';
import FireEvacuationModal from './components/FireEvacuationModal';

export default function App() {
  const [mode, setMode] = useState('idle'); // 'idle' | 'check-in' | 'check-out' | 'staff-attendance'
  const [evacuationOpen, setEvacuationOpen] = useState(false);

  // Inactivity timeout: reset to idle after 90s of no interaction
  const resetToIdle = useCallback(() => {
    setMode('idle');
  }, []);

  useEffect(() => {
    if (mode === 'idle') return;

    let timeoutId;
    const handleUserActivity = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(resetToIdle, 90000); // 90 seconds
    };

    window.addEventListener('touchstart', handleUserActivity);
    window.addEventListener('mousedown', handleUserActivity);
    window.addEventListener('keydown', handleUserActivity);

    timeoutId = setTimeout(resetToIdle, 90000);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('touchstart', handleUserActivity);
      window.removeEventListener('mousedown', handleUserActivity);
      window.removeEventListener('keydown', handleUserActivity);
    };
  }, [mode, resetToIdle]);

  return (
    <main className="min-h-screen flex flex-col justify-between bg-[#0b0f19] text-slate-100 relative selection:bg-cyan-500 selection:text-slate-950">
      {mode === 'idle' && (
        <IdleScreen
          onCheckIn={() => setMode('check-in')}
          onCheckOut={() => setMode('check-out')}
          onStaffAttendance={() => setMode('staff-attendance')}
          onOpenEvacuation={() => setEvacuationOpen(true)}
        />
      )}

      {mode === 'check-in' && (
        <CheckInFlow
          onCancel={resetToIdle}
          onComplete={resetToIdle}
        />
      )}

      {mode === 'check-out' && (
        <CheckOutFlow
          onCancel={resetToIdle}
          onComplete={resetToIdle}
        />
      )}

      {mode === 'staff-attendance' && (
        <StaffAttendanceFlow
          onBack={resetToIdle}
        />
      )}

      <FireEvacuationModal
        isOpen={evacuationOpen}
        onClose={() => setEvacuationOpen(false)}
      />
    </main>
  );
}
